module.exports = __webpack_public_path__ + "static/media/asahi-mizuno-icon.80a3965f.jpg";